// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Entrada do React
// ═══════════════════════════════════════════════════════════════════
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LimiteDeErro } from "./components/ui/LimiteDeErro";
import { iniciarObservabilidade, iniciarTracing, capturarErro } from "./lib/observabilidade";

// Antes de qualquer render: erro que acontece durante o boot precisa ser
// capturado, e não há outra chance depois.
iniciarObservabilidade().catch((e) => console.warn("[obs] Sentry nao iniciou:", e?.message));

// Tracing entra sem bloquear a primeira pintura — e só existe se houver
// endpoint configurado (o import é dinâmico lá dentro).
iniciarTracing().catch((e) => console.warn("[obs] tracing não iniciou:", e?.message));

// ─── Erros fora do React ────────────────────────────────────────────
// O handler anterior fazia `document.body.innerHTML = ...` em QUALQUER
// erro de window: o script de planilha do CDN (#20), uma extensão de
// navegador ou um ruído de ResizeObserver apagavam a sessão inteira, com
// trabalho não salvo junto. E injetavam a mensagem sem escapar.
//
// Agora o erro é reportado e registrado; a tela continua de pé. O que
// quebra no render é tratado pelo LimiteDeErro, que é quem sabe o que
// falhou e consegue oferecer um caminho de volta.
window.addEventListener("error", (e) => {
  capturarErro(e.error || new Error(e.message));
  console.error("[erro não tratado]", e.message, e.filename + ":" + e.lineno);
});

window.addEventListener("unhandledrejection", (e) => {
  capturarErro(e.reason);
  console.error("[promise rejeitada]", e.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LimiteDeErro>
      <App />
    </LimiteDeErro>
  </React.StrictMode>
);
